<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.invoice.show') +' '+ invoice.InvoiceNumber"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <back-button></back-button>

                <div class="d-inline-block float-right">
                    <button class="btn btn-danger" @click="generate('pdf')">
                        <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.pdf')}}
                    </button>
                    <button class="btn btn-primary" @click="generate('word')">
                        <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.word')}}
                    </button>
                </div>

                <hr>

                <div class="row">
                    <div class="col-md-10 mx-auto">
                        <div class="card" style="padding: 100px 40px; font-size: 95%; width: 720px;margin: 0 auto;">

                            <div class="card-body">
                                    <div class="row offset-md-8  col-4">
                                            <p class="mb-0 w-100">{{invoicePerson.Title}} {{invoicePerson.FirstName}}
                                                {{invoicePerson.LastName}}</p>
                                            <p class="mb-0 w-100" v-if="invoicePerson.CompanyName">{{invoicePerson.CompanyName}}</p>
                                            <p class="mb-0 w-100">{{invoicePerson.StreetAddress}}</p>
                                            <p class="mb-0 w-100">{{invoicePerson.Zip}} {{invoicePerson.City}}</p>
                                            <p class="mb-0 w-100">{{invoicePerson.Country}}</p>

                                             <p class="mt-5 w-100">
                                                {{$t('form.invoice.zurich')}} {{invoice.InvoiceDate | formatDate(dateFormat)}}
                                             </p>
                                    </div>

                                <!-- <div class="clearfix"></div> -->

                                <div>
                                    <p><strong>{{$t('form.invoice.invoiceNo')}} {{invoice.InvoiceNumber}}</strong></p>
                                </div>
                                <div >
                                    <p>{{$t('form.invoice.dear')}} {{invoicePerson.Title}} {{invoicePerson.LastName}},
                                    </p>
                                    <p>{{$t('form.invoice.makePaymentText')}}</p>
                                    <div>
                                        <p class="font-weight-bold d-inline">
                                        <template v-if="invoice.PaymentPlan == 'Full Payment'">
                                        <table class='table table-sm my-4'>
                                          <tr v-if="program"  class="d-flex">
                                            <td class="text-left col-10"><span style="font-weight:bolder">{{$t('form.invoice.tuition_for_full_payment_invoices',{
                                                ProgramType:program.ProgramType,
                                                ProgramTitle:program.ProgramTitle,
                                                ProgramYear:program_year[0]
                                                })}}<span v-if="invoice.Discount">{{$t('form.invoice.with_grant')}}</span>:</span>
                                            </td>
                                            <td v-if="invoice.Discount > 0" class="text-right col-2"><span>{{invoice.Currency}} {{invoice.DiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            <td v-else class="text-right col-2"><span>{{invoice.Currency}} {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            <td class="w-10"></td>
                                          </tr>
                                          <tr class="d-flex" v-for="(course, index) in invoice.invoice_course" v-bind:key="index">
                                                <td v-if="invoice.invoice_course[index].course.grade_detail"
                                                class="text-left col-10"><span>-{{$t('form.invoice.less_deductible',{
                                                CourseCode:invoice.invoice_course[index].course.CourseCode,
                                                CourseTitle:invoice.invoice_course[index].course.CourseTitle
                                                })}}</span></td>

                                                <td v-if="invoice.invoice_course[index].course.grade_detail"
                                                class="text-right col-2"><span>{{invoice.Currency}}
                                                {{per_course | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            </tr>
                                           <tr  v-if="program"  class="d-flex">
                                                <td class="text-left col-10"><span class=" font-weight-bold ">-{{$t('form.invoice.less_full_payment_discount')}} ({{invoicePerson.FullPaymentDiscount}}% ):</span></td>
                                                <td class="text-right col-2"><span>{{invoice.Currency}} {{full_deduction | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                                <td class="w-10"></td>
                                           </tr>
                                           <tr  v-if="program"  class="d-flex">
                                                <td class="text-left font-weight-bold  col-9"></td>
                                                <td class="text-right col-3"><span class="font-weight-bold" style="text-decoration: overline 2px black">{{$t('form.invoice.total')}}: {{invoice.Currency}}{{invoice.FullPaymentDiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                                <td class="w-10"></td>
                                           </tr>
                                         </table>
                                        </template>
                                        <template v-else-if="program && program.BillingCycle == 'term' &&
                                        invoice.PaymentPlan == 'by Course/Semester/Term' &&
                                        invoice.invoice_course && invoice.invoice_course.length > 0">
                                        <table class='table table-sm my-4' v-if="program">
                                            <tr  class="d-flex">
                                                <td class="text-left col-10"><span style="font-weight:bolder">
                                                {{$t("form.invoice.tuition_for_semester_deductible_course",{
                                                Semester:invoice.invoice_course[0].course.course_date.Semester,
                                                ProgramType:program.ProgramType,
                                                SemesterFrom:getDateWithMonthAndYear(invoice.invoice_course[0].course.course_date.SemesterFrom),
                                                SemesterTo:getDateWithMonthAndYear(invoice.invoice_course[0].course.course_date.SemesterTo)
                                                })}} <span v-if="invoice.Discount">{{$t('form.invoice.with_grant')}}:</span></span></td>
                                                <td v-if="invoice.Discount > 0" class="text-right col-2"><span>{{invoice.Currency}} {{invoice.DiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                                <td v-else class="text-right col-2"><span>{{invoice.Currency}} {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                                <td class=""></td>
                                            </tr>

                                            <tr class="d-flex" v-for="(course, index) in invoice.invoice_course" v-bind:key="index">
                                                <td v-if="invoice.invoice_course[index].course.grade_detail"
                                                class="ml-1 text-left col-10"><span>-{{$t('form.invoice.less_deductible',{
                                                CourseCode:invoice.invoice_course[index].course.CourseCode,
                                                CourseTitle:invoice.invoice_course[index].course.CourseTitle
                                                })}}</span></td>
                                                <td v-if="invoice.invoice_course[index].course.grade_detail"
                                                class="text-right col-2">
                                                <span>{{invoice.Currency}} {{per_course |
                                                curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            </tr>
                                            <tr class="d-flex">
                                                <td class="text-left font-weight-bold col-9">  {{$t('form.invoice.total_for_semester',{
                                                SemesterNo:invoice.Installment})}}</td>
                                                <td class="text-right col-3" style="text-decoration:overline"><span>{{invoice.Currency}} {{invoice.AmountAfterDeductibles | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            </tr>

                                        </table>
                                        </template>
                                        <template v-else-if="invoice.DueDate == null &&
                                            program && program.BillingCycle == 'course' &&
                                            Number(invoice.Amount) == 0 &&
                                            Number(invoice.Discount) == 0 &&
                                            Number(invoice.DiscountedAmount) == 0 && invoice.PaymentPlan == 'by Course/Semester/Term'">
                                            <table class='table table-sm my-4'>
                                                <tr v-if="program" class="d-flex">
                                                    <td class="text-left col-10"><span style="font-weight:bolder">
                                                    {{$t("form.invoice.tuition_for_deductible_course",{CourseCode:invoice.invoice_course[0].course.CourseCode
                                                    ,CourseTitle:invoice.invoice_course[0].course.CourseTitle,
                                                    ProgramType:program.ProgramType,
                                                    CourseFrom:getDateWithMonthInEnglish(invoice.invoice_course[0].course.course_date.CourseFrom),
                                                    CourseTo:getDateWithMonthInEnglish(invoice.invoice_course[0].course.course_date.CourseTo)
                                                    })}}:</span></td>
                                                    <td class="text-right col-2"><span>{{invoice.Currency}} {{invoice.invoice_course[0].course.course_date.Fee | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                                    <td class=""></td>
                                                </tr>
                                                <tr v-if="program" class="d-flex">
                                                    <td class="ml-1 text-left col-10"><span>-{{$t('form.invoice.less_deductible',{
                                                    CourseCode:invoice.invoice_course[0].course.CourseCode,CourseTitle:invoice.invoice_course[0].course.CourseTitle
                                                        })}}</span></td>
                                                    <td class="text-right col-2"><u>{{invoice.Currency}} {{invoice.invoice_course[0].course.course_date.Fee | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</u></td>
                                                    <td class=""></td>
                                                </tr>
                                                <tr v-if="program" class="d-flex">
                                                    <td class="text-left font-weight-bold col-11"></td>
                                                    <td class="text-right col-1"><span>{{invoice.Currency}} {{0 | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                                    <td class=""></td>
                                                </tr>
                                            </table>
                                        </template>
                                        <template v-else-if="Number(invoice.Discount) > 0 &&
                                                            invoice.PaymentPlan != 'Full Payment'">
                                            {{invoice.InvoicePurpose}} {{$t('form.invoice.with_grant')}}
                                            {{invoice.Currency}}
                                            {{invoice.DiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}

                                        </template>
                                        <template v-else>
                                            {{invoice.InvoicePurpose}}:
                                            <strong class="ml-5">{{invoice.Currency}} {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</strong>
                                        </template>
                                        </p>
                                    </div>

                                    <p class="font-weight-italic">
                                        <template v-if="total > 0">
                                            {{$t('form.invoice.installmentText', {num: invoice.Installment, total: total})}}
                                        </template>
                                    </p>

                                    <p class="mt-3 mb-0">{{$t('form.invoice.bankDetails')}}</p>
                                    <div class="pt-3">
                                        <p class="mb-0">{{bank.beneficiary}}</p>
                                        <p class="mb-0">{{bank.name}}</p>
                                        <p class="mb-0">{{bank.account_no}}</p>
                                        <p class="mb-0">{{bank.swift_code}}</p>
                                        <p class="mb-0">{{bank.clearing_no}}</p>
                                        <p class="mb-0">{{bank.iban}}</p>
                                    </div>
                                    <p class="mt-3">{{$t('form.invoice.exemptedFromVAT')}}</p>
                                </div>

                                <div class="mt-0">
                                    <p class="mb-0">{{$t('form.invoice.askForPaymentText')}} <span
                                            class="font-weight-bold">{{$t('form.invoice.by')}}
                                            {{invoice.DueDate | formatDate(dateFormat)}}</span>. </p>

                                            <p class="mt-3">
                                                <strong>{{$t('form.invoice.bankingFees')}}</strong>
                                            </p>
                                    <p class="mt-5">{{$t('form.invoice.thankForCollaboration')}}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat', 'decimalDigits', 'decimalPoint', 'thousandSeparator'],

        data() {
            return {
                isLoading: false,
                fullPage: true,

                program:null,
                program_year:null,
                scholarship_deduction:null,
                full_deduction:null,
                total:0,amount_after_deductibles:0,
                courses:[],
                free_courses:[],
                per_course:null,
                term_fee:0,
                student:{},


                invoice: {
                    Amount: null,
                    Currency: null,
                    DueDate: null,
                    ID: null,
                    InvoiceDate: null,
                    InvoiceNumber: null,
                    InvoicePurpose: null,
                    Paid: null,
                    PaymentDate: null,
                    TS: null
                },

                invoicePerson: {
                    FirstName: "",
                    LastName: "",
                    Title: null,
                    CompanyName: null,
                    StreetAddress: null,
                    City: null,
                    Zip: null,
                    Country: null,
                },

                bank: {},
                availableFormats: ['pdf', 'word']
            }
        },

        async mounted() {
            if (!this.permissions.viewInvoices) {
                this.$router.push("/");
                return;
            }
            await this.getConfig();
            this.getInvoice();
        },

        methods: {
            async getConfig(){
                var self = this;
                try{
                    const response = await axios.get('/api/config');
                    if (response.data) {
                        let config = response.data;
                        self.free_courses = config.free_courses;
                    }
                }catch(error){
                    console.log('error in getting config values')
                }
            },
            getDateWithMonthInEnglish(date){
                var dateFormat = 'DD MMM YYYY';
                var formattedDate = date ? moment(date).format(dateFormat) : moment().format(dateFormat);
                return formattedDate;
            },
            getDateWithMonthAndYear(date){
                var dateFormat = 'MMM YYYY';
                var formattedDate = date ? moment(date).format(dateFormat) : moment().format(dateFormat);
                return formattedDate;
            },
            getBank() {
                this.isLoading = true;

                axios
                    .get(`/api/bank-details?currency=${this.invoice.Currency}`)
                    .then(response => {
                        this.isLoading = false;
                        this.bank = response.data
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error fetching bank details.');
                    });
            },

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {type});
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async generate(type = null) {
                if (!this.availableFormats.includes(type)) return;

                let token = await this.createToken('student-attachment');
                if (token == '') return;

                window.open(`/invoices/${this.$route.params.id}/${type}?token=${token}`, '_blank');
            },

            getInvoice() {
                this.isLoading = true;

                if (!this.$route.params.id) return;

                axios
                    .get(`/api/invoices/${this.$route.params.id}`)
                    .then(response => {
                        this.isLoading = false;
                        this.invoice = response.data;
                        this.student = this.invoice.student[0];
                        if (this.invoice.student.length) {
                            this.invoicePerson = this.invoice.student[0];
                            if(this.invoice.Discount>0)
                            this.scholarship_deduction = (this.invoice.Amount - this.invoice.DiscountedAmount).toFixed(2);
                            else
                            this.scholarship_deduction = 0;
                            this.program = this.invoice.student[0].programs[0];
                            this.courses = this.program.program_courses;

                            if(this.invoice.PaymentPlan == 'Full Payment'){
                                var paid_courses = 0;
                                for(var $i = 0 ;$i<this.courses.length;$i++){
                                    if (!(this.free_courses.includes(this.courses[$i]['CourseCode']))){
                                        paid_courses = paid_courses + 1;
                                    }
                                }
                                if(paid_courses > 0){
                                    if(this.invoice.Discount > 0){
                                    this.per_course = this.invoice.DiscountedAmount/paid_courses;
                                    }else{
                                    this.per_course = this.invoice.Amount/paid_courses;
                                    }
                                }
                                else{
                                this.per_course = 0;

                                }

                                this.full_deduction = (this.invoice.AmountAfterDeductibles - this.invoice.FullPaymentDiscountedAmount).toFixed(2);
                            }else if(this.invoice.PaymentPlan == 'by Course/Semester/Term'){
                                if(this.program.BillingCycle == 'course'){

                                }else if(this.program.BillingCycle == 'term'){

                                    this.term_fee = this.program.TermFee[(this.invoice.Installment)-1]
                                    var semester_courses = 0;

                                    for(var i = 0 ;i<this.courses.length;i++){
                                        if(this.courses[i]['pivot']['Semester']){
                                            if(this.courses[i]['pivot']['Semester'] == this.invoice.Installment &&
                                            (!(this.free_courses.includes(this.courses[i]['CourseCode']))) &&
                                            this.courses[i]['pivot']['SemesterFrom']){
                                            semester_courses = semester_courses + 1;
                                            }
                                        }
                                    }
                                    if(semester_courses>0)
                                    this.per_course = this.term_fee/semester_courses;
                                    else
                                    this.per_course = 0
                                }
                            }
                            var str = this.program.AcademicYear;
                            this.program_year = str.split("-");
                        } else if (this.invoice.company.length) {
                            this.invoicePerson.Title = this.invoice.company[0].ContactPersonTitle;
                            this.invoicePerson.FirstName = this.invoice.company[0].ContactPersonFirstName;
                            this.invoicePerson.LastName = this.invoice.company[0].ContactPersonLastName;
                            this.invoicePerson.CompanyName = this.invoice.company[0].CompanyName;
                            this.invoicePerson.StreetAddress = this.invoice.company[0].StreetAddress;
                            this.invoicePerson.Zip = this.invoice.company[0].Zip;
                            this.invoicePerson.City = this.invoice.company[0].City;
                            this.invoicePerson.Country = this.invoice.company[0].Country;
                        }

                        this.getBank();
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    });
            }
        },

    }

</script>
<style scoped>

.underlined {
    border-bottom: 5px double;
}

.w-20 {
  width: 20%;
}

.w-50 {
  width: 50%;
}


.w-10 {
  width: 10%;
}

table {
  table-layout:fixed;/* will switch the table-layout algorythm */
}
table td{
    border-top : none !important;
}
.borderless td, .borderless th {
    border: none;
}
tr td {
    padding-top: 0em;
}
u {
  padding-bottom:3px;
  text-decoration:none;
  border-bottom:2px solid #4a4e51;
}
</style>
